import React from "react";
import { Link } from "react-router-dom";
import image1 from "../../../images/agency/agent/1.jpg";
import image2 from "../../../images/agency/agent/4.jpg";
import image3 from "../../../images/agency/agent/2.jpg";
import { MdEmail } from "react-icons/md";
import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";
import "./Team.css";

const Team = () => {
  const decor = {
    textDecoration: "none",
  };

  return (
    <div className="team-container">
      <div className="team-wrapper">
        <div className="team-img-container">
          <img className="team-img" src={image1} alt="image1" />
        </div>
        <div className="team-bg">
          <h5>Anna Lips</h5>
          <h4>Software Engineer</h4>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas in
            pulvinar neque. Nulla...
          </p>
          <hr className="hr" />
          <div className="team-user">
            <div className="user">
              <MdEmail className="userr" />
            </div>
            <div className="rating">
              <div className="user-contact">
                <Link style={decor} to="/about">
                  <FaFacebookF className="userr" />
                </Link>
                <Link style={decor} to="/about">
                  <FaInstagram className="userr" />
                </Link>
                <Link style={decor} to="/about">
                  <FaTwitter className="userr" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="team-wrapper">
        <div className="team-img-container">
          <img className="team-img" src={image3} alt="image1" />
        </div>
        <div className="team-bg">
          <h5>Jane Kobart</h5>
          <h4>Business consultant</h4>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas in
            pulvinar neque. Nulla...
          </p>
          <hr className="hr" />
          <div className="team-user">
            <div className="user">
              <MdEmail className="userr" />
            </div>
            <div className="rating">
              <div className="user-contact">
                <Link style={decor} to="/about">
                  <FaFacebookF className="userr" />
                </Link>
                <Link style={decor} to="/about">
                  <FaInstagram className="userr" />
                </Link>
                <Link style={decor} to="/about">
                  <FaTwitter className="userr" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="team-wrapper">
        <div className="team-img-container">
          <img className="team-img" src={image2} alt="image1" />
        </div>
        <div className="team-bg">
          <h5>Bill Trust</h5>
          <h4>Developer / Designer</h4>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas in
            pulvinar neque. Nulla...
          </p>
          <hr className="hr" />
          <div className="team-user">
            <div className="user">
              <MdEmail className="userr" />
            </div>
            <div className="rating">
              <div className="user-contact">
                <Link style={decor} to="/about">
                  <FaFacebookF className="userr" />
                </Link>
                <Link style={decor} to="/about">
                  <FaInstagram className="userr" />
                </Link>
                <Link style={decor} to="/about">
                  <FaTwitter className="userr" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
